import {useQuery} from 'react-query';
import {campaignService} from 'src/shared/services/campaigns';

export const useGetCampaignsHistory = (id: string) => {
  return useQuery(['campaigns-his'], () => campaignService.campaignHistory(id));
};
